import { render, staticRenderFns } from "./PagedTabsTableViewForActivityApply.vue?vue&type=template&id=d4f90fb8&"
import script from "./PagedTabsTableViewForActivityApply.vue?vue&type=script&lang=ts&"
export * from "./PagedTabsTableViewForActivityApply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports